import React, { useState } from "react";
import HtmlContent from "./HtmlContent";

const CollapsibleSection = ({
	title,
	content,
	isDefaultOpen = false,
	sectionKey,
}) => {
	const [isOpen, setIsOpen] = useState(isDefaultOpen);

	const toggleSection = () => {
		setIsOpen(!isOpen);
	};

	// Check if content is map content
	const isMapContent =
		typeof content === "string" &&
		content.includes("<!DOCTYPE html>") &&
		(content.includes("leaflet") ||
			content.includes("L.map") ||
			content.includes("folium-map"));

	return (
		<div className="collapsible-section">
			<div
				className={`section-header1 ${isOpen ? "active" : ""}`}
				onClick={toggleSection}
				title={isOpen ? "Click to collapse" : "Click to expand"}
			>
				<div className="section-title-container">
					<h4 className="section-title">{title}</h4>
					<span className="section-expand-hint">
						{isOpen ? "Click to collapse" : "Click to expand"}
					</span>
				</div>
				<div className="section-icon-container">
					<svg
						className={`section-icon ${isOpen ? "expanded" : ""}`}
						width="24"
						height="24"
						fill="none"
						stroke="currentColor"
						viewBox="0 0 24 24"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={2}
							d="M19 9l-7 7-7-7"
						/>
					</svg>
				</div>
			</div>

			{isOpen && (
				<div className="section-content">
					{isMapContent ? (
						<div style={{ width: "100%", height: "400px" }}>
							<iframe
								srcDoc={content}
								style={{
									width: "100%",
									height: "100%",
									border: "none",
									borderRadius: "4px",
								}}
								title={`${title} Map`}
							/>
						</div>
					) : (
						<HtmlContent className="prose" html={content} />
					)}
				</div>
			)}
		</div>
	);
};

export default CollapsibleSection;
